import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorizontalStatusTrackingComponent } from './horizontal-status-tracking.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { TimezoneModule } from '../timezone/timezone.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [HorizontalStatusTrackingComponent],
  imports: [CommonModule, TooltipModule, IntrackFeatureModule, TranslateModule, TimezoneModule, SvgIconModule],
  exports: [HorizontalStatusTrackingComponent],
})
export class HorizontalStatusTrackingModule {}
